import { Component, Input, OnInit } from '@angular/core';
import { MaintenanceService } from '../../../services/maintenanceService';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forecast-admin-management',
    templateUrl: './forecast-admin-management.component.html',
    styleUrl: './forecast-admin-management.component.css',
    standalone: false
})
export class ForecastAdminManagementComponent implements OnInit {
  @Input() isForecastAdmin: boolean = false;
  @Input() segmentData: any = [];
  selectedTab: string = 'forecast_master';
  tabs: Array<any> = [];
  currentYear = new Date().getFullYear();
  forecastTriggerRecipients: string = '';
  constructor(
    public maintenanceService: MaintenanceService,
    public dialog: MatDialog,
    private toasterService: ToastrService
  ) {}
  ngOnInit(): void {
    this.getTabs();
    this.resetForecastTrigger();
  }

  //get All the tabs
  getTabs() {
    this.tabs = [
      { label: 'Forecast Master', value: 'forecast_master' },
      { label: 'Service Management', value: 'forecast_service_management' },
      { label: 'Role Management', value: 'forecast_role_management' },
      { label: 'Forecast Multi Matrix', value: 'forecast_multi_matrix' },
      // { label: 'Projections Workflow', value: 'projections_workflow' }
    ];
  }

  tabChangeClick(event) {
    this.selectedTab = this.tabs[event.index].value;
    this.resetForecastTrigger();
  }

  triggerWorkflow() {
    const payload = {
      recipients: this.forecastTriggerRecipients,
    };
    if (this.selectedTab === 'projections_workflow') {
      payload['type'] = 'Projections';
      this.triggerWorkflowAPI(payload);
    }
  }

  triggerWorkflowAPI(payload) {
    this.maintenanceService.triggerDataBricksWorkflow(payload).subscribe(
      response => {
        this.toasterService.success(response, '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.resetForecastTrigger();
      },
      error => {
        console.log('error', error);
        this.toasterService.error('Error in Triggering Workflow', '', {
          timeOut: 3000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }

  resetForecastTrigger() {
    this.forecastTriggerRecipients = '';
  }
}
